module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"about_hscmap":"About hscMap","reset_all":"Reset All Settings"},"ja":{"about_hscmap":"hscMapについて","reset_all":"全ての設定をリセット"}}')
  delete Component.options._Ctor
}
